import { useGetAgendaModule } from "@/hooks/queryHooks/agendaModuleHooks";
import { AppUrlPath } from "@/lib/AppUrlPath";
import { Button } from "@repo/ui/components/Base/Button";
import { useNavigate } from "react-router-dom";

export const AgendaModuleDisplay = ({
  tenantId,
  meetingId,
  agendaId,
  agendaModuleId,
  showItems = true,
}: {
  tenantId: string;
  meetingId?: string;
  agendaId?: string;
  agendaModuleId: string;
  showItems?: boolean;
}) => {
  const navigate = useNavigate();

  const { data: agendaModule } = useGetAgendaModule(tenantId, agendaModuleId);

  const handleViewModule = () => {
    const appUrlPath = new AppUrlPath(tenantId);
    navigate(appUrlPath.getAgendaModulePath(agendaModuleId));
  };

  const handleViewItem = (itemId: string) => {
    const appUrlPath = new AppUrlPath(tenantId);
    if (meetingId && agendaId) {
      navigate(
        appUrlPath.getMeetingAgendaItemPath(meetingId, agendaId, itemId)
      );
      return;
    }
    navigate(appUrlPath.getAgendaItemPath(itemId));
  };
  return (
    <div className="p-2 mb-2 bg-secondary bg-opacity-25 rounded-lg">
      <div className="flex flex-row justify-between">
        <h2 className="text-xl p-2">{agendaModule?.name ?? "..."}</h2>
        <Button type="button" onClick={() => handleViewModule()}>
          View
        </Button>
      </div>
      {showItems && !!agendaModule?.agendaItems?.length && (
        <div className="flex flex-col gap-2 mt-3">
          {agendaModule.agendaItems?.map((agendaItem, index) => (
            <div
              key={index}
              className="p-2 bg-secondary bg-opacity-75 rounded-lg text-secondary-foreground flex flex-col"
            >
              <div className="flex flex-row justify-between gap-x-2">
                <h3 className="text-lg">{agendaItem.name}</h3>
                <Button
                  type="button"
                  onClick={() => handleViewItem(agendaItem.id)}
                >
                  View
                </Button>
              </div>
              <div className="flex flex-row justify-between">
                <div>
                  {agendaItem.documents?.map((doc) => (
                    <div key={doc.id}>{doc.name}</div>
                  ))}
                </div>
                <div></div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
